import { render, staticRenderFns } from "./branches_dropdown.vue?vue&type=template&id=2a5aa854"
import script from "./branches_dropdown.vue?vue&type=script&lang=js"
export * from "./branches_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports